import { LOCALES_TO_EXCLUDE } from 'utils/getLocaleId'

export const HARDCODE_LANGS = [
  {
    id: 1,
    locale: 'en',
    name: 'English',
    __typename: 'Locale',
  },
  {
    id: 3,
    locale: 'fr',
    name: 'Française',
    __typename: 'Locale',
  },
  {
    id: 4,
    locale: 'es',
    name: 'Español',
    __typename: 'Locale',
  },
  {
    id: 5,
    locale: 'it',
    name: 'Italiano',
    __typename: 'Locale',
  },
  {
    id: 6,
    locale: 'de',
    name: 'Deutsche',
    __typename: 'Locale',
  },
  {
    id: 2,
    locale: 'ru',
    name: 'Русский',
    __typename: 'Locale',
  },
  {
    id: 7,
    locale: 'zh',
    name: '中國人',
    __typename: 'Locale',
  },
].filter(item => !LOCALES_TO_EXCLUDE.includes(item.locale))
